var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeyaaHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 724 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.56 46.84H278V144.76H335.28V159H260.56V46.84ZM347.17 118.2C347.17 93.56 363.49 76.12 386.69 76.12C409.89 76.12 426.05 93.56 426.05 118.2V122.52H364.29C365.73 137.08 374.05 146.2 386.69 146.2C396.61 146.2 404.45 140.76 407.65 131.48L423.49 135C419.01 150.04 405.25 160.28 386.69 160.28C363.49 160.28 347.17 142.84 347.17 118.2ZM364.77 110.2H408.45C406.37 97.72 398.05 90.2 386.69 90.2C375.17 90.2 367.17 97.72 364.77 110.2ZM431.333 77.72H448.613L471.333 137.88L493.893 77.72H511.013L476.613 166.2C471.653 179.16 465.573 193.24 446.213 193.24C442.053 193.24 437.093 192.6 432.933 191.32V177.4C439.173 179.16 442.373 179.64 445.253 179.64C455.173 179.64 458.853 171.32 461.733 163.48L463.493 158.84L431.333 77.72ZM566.883 159C566.243 156.44 565.123 151 564.803 148.44C559.043 155.64 550.563 160.44 540.643 160.44C523.683 160.44 512.483 150.36 512.483 135.32C512.483 121.24 525.283 112.28 546.562 109.88L564.003 107.8V104.28C564.003 95.96 557.923 90.2 549.443 90.2C541.283 90.2 534.883 94.2 532.963 101.08L516.643 98.36C520.003 84.92 532.643 76.12 549.603 76.12C568.163 76.12 580.963 88.12 580.963 106.52V135.32C580.963 147.16 581.123 152.76 581.923 159H566.883ZM529.443 134.68C529.443 141.72 535.203 146.68 543.843 146.68C556.323 146.68 564.003 138.36 564.003 125.88V119.32L547.043 121.4C536.163 122.68 529.443 127.32 529.443 134.68ZM650.32 159C649.68 156.44 648.56 151 648.24 148.44C642.48 155.64 634 160.44 624.08 160.44C607.12 160.44 595.92 150.36 595.92 135.32C595.92 121.24 608.72 112.28 630 109.88L647.44 107.8V104.28C647.44 95.96 641.36 90.2 632.88 90.2C624.72 90.2 618.32 94.2 616.4 101.08L600.08 98.36C603.44 84.92 616.08 76.12 633.04 76.12C651.6 76.12 664.4 88.12 664.4 106.52V135.32C664.4 147.16 664.56 152.76 665.36 159H650.32ZM612.88 134.68C612.88 141.72 618.64 146.68 627.28 146.68C639.76 146.68 647.44 138.36 647.44 125.88V119.32L630.48 121.4C619.6 122.68 612.88 127.32 612.88 134.68Z",
    fill: "#0A2540"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 188,
    height: 188,
    rx: 44,
    fill: "#635BFF",
    stroke: "#9C83FF",
    strokeWidth: 12,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 129.2,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 129.2,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 129.2,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 129.2,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 90,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 90,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 133C50 131.343 51.3431 130 53 130H67C68.6569 130 70 131.343 70 133V147C70 148.657 68.6569 150 67 150H53C51.3431 150 50 148.657 50 147V133Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 133C50 131.343 51.3431 130 53 130H67C68.6569 130 70 131.343 70 133V147C70 148.657 68.6569 150 67 150H53C51.3431 150 50 148.657 50 147V133Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3536 140.354C84.5488 140.158 84.5488 139.842 84.3536 139.646L81.1716 136.464C80.9763 136.269 80.6597 136.269 80.4645 136.464C80.2692 136.66 80.2692 136.976 80.4645 137.172L83.2929 140L80.4645 142.828C80.2692 143.024 80.2692 143.34 80.4645 143.536C80.6597 143.731 80.9763 143.731 81.1716 143.536L84.3536 140.354ZM76 140.5H84V139.5H76V140.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.354 140.354C124.549 140.158 124.549 139.842 124.354 139.646L121.172 136.464C120.976 136.269 120.66 136.269 120.464 136.464C120.269 136.66 120.269 136.976 120.464 137.172L123.293 140L120.464 142.828C120.269 143.024 120.269 143.34 120.464 143.536C120.66 143.731 120.976 143.731 121.172 143.536L124.354 140.354ZM116 140.5H124V139.5H116V140.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78 77.5C77.7239 77.5 77.5 77.7239 77.5 78V82.5C77.5 82.7761 77.7239 83 78 83C78.2761 83 78.5 82.7761 78.5 82.5V78.5H82.5C82.7761 78.5 83 78.2761 83 78C83 77.7239 82.7761 77.5 82.5 77.5H78ZM84.0104 83.3033L78.3536 77.6465L77.6465 78.3536L83.3033 84.0104L84.0104 83.3033Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116 115.5C115.724 115.5 115.5 115.724 115.5 116V120.5C115.5 120.776 115.724 121 116 121C116.276 121 116.5 120.776 116.5 120.5V116.5H120.5C120.776 116.5 121 116.276 121 116C121 115.724 120.776 115.5 120.5 115.5H116ZM122.01 121.303L116.354 115.646L115.646 116.354L121.303 122.01L122.01 121.303Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6464 84.3536C59.8417 84.5488 60.1583 84.5488 60.3536 84.3536L63.5355 81.1716C63.7308 80.9763 63.7308 80.6597 63.5355 80.4645C63.3403 80.2692 63.0237 80.2692 62.8284 80.4645L60 83.2929L57.1716 80.4645C56.9763 80.2692 56.6597 80.2692 56.4645 80.4645C56.2692 80.6597 56.2692 80.9763 56.4645 81.1716L59.6464 84.3536ZM59.5 76V84H60.5V76H59.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6464 124.354C59.8417 124.549 60.1583 124.549 60.3536 124.354L63.5355 121.172C63.7308 120.976 63.7308 120.66 63.5355 120.464C63.3403 120.269 63.0237 120.269 62.8284 120.464L60 123.293L57.1716 120.464C56.9763 120.269 56.6597 120.269 56.4645 120.464C56.2692 120.66 56.2692 120.976 56.4645 121.172L59.6464 124.354ZM59.5 116V124H60.5V116H59.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeyaaHeaderLogo);
export default __webpack_public_path__ + "static/media/leyaa-header-logo.7af6ea2ee43524e6755470559695fbfe.svg";
export { ForwardRef as ReactComponent };